import connectConfigureRelatedItems from 'instantsearch.js/cjs/connectors/configure-related-items/connectConfigureRelatedItems';
import type { ConfigureRelatedItemsConnectorParams } from 'instantsearch.js/cjs/connectors/configure-related-items/connectConfigureRelatedItems';
import { useConnector } from 'react-instantsearch';
import type { AdditionalWidgetProperties } from 'react-instantsearch';

export type UseConfigureRelatedItemsProps = ConfigureRelatedItemsConnectorParams;

const useConfigureRelatedItems = (
  props: UseConfigureRelatedItemsProps,
  additionalWidgetProperties?: AdditionalWidgetProperties,
) => {
  return useConnector(connectConfigureRelatedItems, props, additionalWidgetProperties);
};

export default useConfigureRelatedItems;
